import React from 'react';
import './footer.scss'
import mailSvg from './mail.svg'
import phoneSvg from './phone.svg'
import SocialList from "../social-list/social-list";
import {useTranslation} from "react-i18next";

function Footer() {
    const { t } = useTranslation()
    return (<div className="footer container">
        <div className="footer__logo" data-aos="fade-right">
            <img width={150} src={process.env.REACT_APP_LOGO} alt=""/>
        </div>

        <div className="footer__columns">

            <div className="footer__column" data-aos="fade-right">

                <div className="footer__contact">
                    <div className="footer__contact-item">
                        <img src={mailSvg} alt=""/> <span>{process.env.REACT_APP_MAIL}</span>
                    </div>
                    <div className="footer__contact-item">
                        <img src={phoneSvg} alt=""/> <span>{process.env.REACT_APP_PHONE}</span> <span>{process.env.REACT_APP_PHONE_2}</span>
                    </div>
                </div>

                <SocialList/>

                <div className="footer__mobile-text">
                    <p>{t('footer.text')}</p>
                    <p>{t('footer.text1')}
                        <br/>
                        <br/>
                        {t('footer.text2')}
                       </p>
                </div>

                <span className="footer__copyright">© 2023-2024. All rights reserved. </span>

            </div>

            <div className="footer__column" data-aos="fade-left">
                <p>{t('footer.text')}</p>
                <p>{t('footer.text1')}
                    <br/>
                    <br/>
                    {t('footer.text2')}
                </p>
            </div>
        </div>

    </div>);
}

export default Footer;